import React, { useCallback, useMemo } from 'react';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import { Button, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';
import { useMessages } from 'modules/intl';
import { useBulkCustomSuggestionsActions } from './hooks/useBulkCustomSuggestionsActions';
import { useBulkLabelSuggestionsActions } from './hooks/useBulkLabelSuggestionsActions';

const useStyles = makeStyles((theme) => ({
  btn: {
    padding: theme.spacing(0.7, 2)
  },
  accept: {
    color: theme.palette.success.dark,
    borderColor: theme.palette.success.dark,
    '&:hover': {
      borderColor: theme.palette.success.dark
    }
  },
  overflow: {
    color: theme.palette.text.primary
  }
}));

const messageKeys = ['timesheetLabels.acceptAllSuggestions'];

type BulkSuggestionAcceptAllActionsProps = {
  customLabels: string;
  timesheetLabels: string;
};

export const BulkSuggestionAcceptAllActions: React.FC<BulkSuggestionAcceptAllActionsProps> = ({
  customLabels,
  timesheetLabels
}: BulkSuggestionAcceptAllActionsProps) => {
  const messages = useMessages(messageKeys);
  const classes = useStyles();
  const {
    enableCustomActions,
    acceptAllCustomLabelSuggestionHandler
  } = useBulkCustomSuggestionsActions({
    fieldName: customLabels
  });

  const {
    enableTimesheetActions,
    acceptAllLabelSuggestionHandler
  } = useBulkLabelSuggestionsActions({ fieldName: timesheetLabels });

  const handleAcceptAll = useCallback(() => {
    acceptAllCustomLabelSuggestionHandler?.();
    acceptAllLabelSuggestionHandler?.();
  }, [acceptAllCustomLabelSuggestionHandler, acceptAllLabelSuggestionHandler]);
  const disabled = useMemo(() => {
    return !enableTimesheetActions && !enableCustomActions;
  }, [enableCustomActions, enableTimesheetActions]);
  return (
    <div>
      <Tooltip
        title={messages['timesheetLabels.acceptAllSuggestions']}
        placement="top"
      >
        <Button
          variant="outlined"
          size="medium"
          data-testid="accept-all-suggestions"
          className={classnames(classes.btn, classes.accept)}
          startIcon={<DoneAllIcon />}
          disabled={disabled}
          onClick={handleAcceptAll}
        >
          {messages['timesheetLabels.acceptAllSuggestions']}
        </Button>
      </Tooltip>
    </div>
  );
};
